module.exports = __webpack_public_path__ + "static/media/CSSSprites.60742e3.60742e3d.png";